import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import Rank from '@/_shared/entities/rank/rank.entity';
import ranks from '@/_shared/constants/ranks';
import RankComparison from '@/earn/entities/rank-comparison/rank-comparison.entity';
import RankAchievement from '@/_shared/entities/rank/rank-achievement.entity';
import RankService from '@/_shared/services/rank.service';
import AuthService from '@/_shared/services/auth/auth.service';
import cloneDeep from 'lodash/cloneDeep';

@Component
export default class RankReportMixin extends Vue {
  hashIds = AuthService.getHashIds();
  rankComparison: RankComparison[] = [];
  rankAchievements: RankAchievement[] = []

  get allRanks(): Rank[] {
    const rankConstants: Rank[] = [];
    this.rankComparison.forEach((rank) => {
      const rankConstant = cloneDeep(ranks.find((item: Rank) => item.id === rank.rankId));
      if (!rankConstant) return;
      const rankAchievement = this.rankAchievements
        .find((achievement) => achievement.rankTypeId === rankConstant.id);
      rankConstant.achievementDate = rankAchievement?.rankAdvancementDate;
      rankConstants.push(rankConstant);
    });
    return rankConstants;
  }

  getRankAchievements(repDid: string): Promise<void> {
    return RankService.getRankAchievements(repDid).then((response) => {
      this.rankAchievements = response;
    });
  }

  getRankComparison(repDid: string): Promise<void> {
    return RankService.getRankComparison(repDid, false)
      .then((response) => {
        this.rankComparison = response;
      });
  }
}
